import { render, staticRenderFns } from "./CreateTaskModal.vue?vue&type=template&id=4e0eba15&scoped=true&"
import script from "./CreateTaskModal.vue?vue&type=script&lang=js&"
export * from "./CreateTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0eba15",
  null
  
)

export default component.exports